
<div>
        <input class="form-control"
               bsDaterangepicker
               [(ngModel)]="bsRangeValue"
               (bsValueChange)=this.datePickerOnValueChange.emit($event)
               placeholder="Filter table by date range"
               [bsConfig]="bsConfig"

        >
</div>
